import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, FormGroup, Form} from 'react-bootstrap';
import * as api from '../../../../utilities/api';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, ContentState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {MC_IMAGE_BASE_URL} from '../../../../config';
import {addFlashMessage} from '../../../../actions/jre';
import {convertToRaw} from 'draft-js';
import {isEmpty} from '../../../../utilities/validation';
import SweetAlert from 'sweetalert2-react';

class ExtendedContentEditor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            submitting: false,
            currentHtml: '',
            originalHtml: '',
            htmlHasChanged: false,
            editorState: this.getEditorState(this.props.currentPageHtml),
            showDeletionModal: false,
            showWarningNavigatingAway : false,
        };
        this.getEditorState = this.getEditorState.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleFormClear = this.handleFormClear.bind(this);
        this.removeFormatter = this.removeFormatter.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
        this.uploadCallback = this.uploadCallback.bind(this);
        this.setHtml = this.setHtml.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps){ // eslint-disable-line no-unused-vars
        if (this.props.currentPageHtml !== nextProps.currentPageHtml){ // when changing pages, we need to get the new html
            this.setState({editorState: this.getEditorState(nextProps.currentPageHtml)});
        }
    }

    componentDidUpdate(prevProps, prevState) { // eslint-disable-line no-unused-vars
        const {originalHtml, currentHtml} = this.state;
        this.props.extendedContentHtmlChanged(currentHtml, originalHtml);
    }

    getEditorState(value) {
        if (value instanceof EditorState) {
            return value;
        }
        if (isEmpty(value)) {
            return EditorState.createEmpty();
        }
        if (typeof value === 'string') {
            const contentBlock = htmlToDraft(value);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            return EditorState.createWithContent(contentState);
        }
        throw Error(`Invalid value: ${value}`);
    }

    uploadImage(img){
        return api.uploadQuestionImage(img);
    }

    uploadCallback(file) {
        return this.uploadImage(file).then(({url}) => ({data: {link: MC_IMAGE_BASE_URL + url}}));
    }

    UNSAFE_componentWillMount(){
        this.handleEditorChange(this.state.editorState);
    }

    setHtml(html) {
        if(this.state.originalHtml === ''){
            this.setState({originalHtml : html});
        }
        this.setState({ currentHtml: html });
    }

    toggleDeleteModal(e) {
        // console.log(e);
        this.setState({ showDeletionModal:!this.state.showDeletionModal});  //Naren !this.state.showDeletionModal
    }

    handleEditorChange(editorState) {
        this.setState({
            editorState,
        }, () => {
            this.setHtml(draftToHtml(convertToRaw(editorState.getCurrentContent())));
        });
    }

    removeFormatter(cell, row, enumObject, index) {
        return (
            <a href="javascript:void(0)"  onClick={() => this.handleContentRemove(index)}>
                <i className="fa fa-remove red" />
            </a>
        );
    }

    handleFormClear(e) {
        e.preventDefault();
        this.setState({ submitting:true, showDeletionModal: false });
        const {extendedContentId,extendedtextId,currentPageId, addFlashMessage, extendedContentHtmlChanged,
            disablePreviewButtonWhileSubmitting, disableJREButtonsWhileSubmittingExtendedContent,
            enablePreviewButtonAfterSubmitting, enableJREButtonsWhileSubmittingExtendedContent,pageNum} = this.props;

        let pageList = [];
        let contentObject= {};
        contentObject[currentPageId.toString()] = '';
        pageList.push(contentObject);

        this.setState({originalHtml : '', currentHtml: ''});
        extendedContentHtmlChanged('', '');

        let extendedContentUpdate = JSON.stringify(pageList);

        disablePreviewButtonWhileSubmitting();
        disableJREButtonsWhileSubmittingExtendedContent('submitting');

        const payload = {contentJson:'', extendedContentId:extendedContentId,extendedtextId:extendedtextId,pageid:pageNum};
        this.setState({submitting: true},
            () => api.updateExtendedContentPackage(payload,window.contentparams).then( () => {
                alert('The extended content for this page has been cleared!', 'success');
                this.setState({
                    submitting:false,
                    currentHtml: '',
                    editorState: this.getEditorState(''),
                    showDeletionModal: false,
                    originalHtml: '',
                });
                enablePreviewButtonAfterSubmitting();
                enableJREButtonsWhileSubmittingExtendedContent('submitting');
            }).catch((err) => addFlashMessage(err.data.message, 'error'))
        );
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const {extendedContentId,extendedtextId,currentPageId, addFlashMessage, extendedContentHtmlChanged,
            disablePreviewButtonWhileSubmitting, disableJREButtonsWhileSubmittingExtendedContent,
            enablePreviewButtonAfterSubmitting, enableJREButtonsWhileSubmittingExtendedContent,pageNum} = this.props;
        let {currentHtml} = this.state;

        this.setState({originalHtml : currentHtml});
        extendedContentHtmlChanged(currentHtml, currentHtml);

        let pageList = [];
        let contentObject= {};
        contentObject[currentPageId.toString()] = currentHtml;
        pageList.push(contentObject);

        let extendedContentUpdate = JSON.stringify(pageList[currentPageId]);

        disablePreviewButtonWhileSubmitting();
        disableJREButtonsWhileSubmittingExtendedContent('submitting');

        const payload = {contentJson:currentHtml, extendedContentId:extendedContentId,extendedtextId:extendedtextId,pageid:pageNum};
        this.setState({submitting: true},
            () => api.updateExtendedContentPackage(payload,window.contentparams).then(()=>{
                alert('The extended content for this page has been updated!', 'success');
                this.setState({
                    submitting:false,
                    editorState: this.getEditorState(currentHtml),
                });
                enablePreviewButtonAfterSubmitting();
                enableJREButtonsWhileSubmittingExtendedContent('submitting');
            }).catch((err) => addFlashMessage(err.data.message, 'error'))
        );
    }

    render() {
        const {currentPageName} = this.props;
        const {submitting, editorState,  showDeletionModal = false} = this.state;

        return (
            <div className="extended-form">
                <SweetAlert
                    show={showDeletionModal}
                    confirmButtonText="CONFIRM"
                    cancelButtonText="CANCEL"
                    focusConfirm={false}
                    type="warning"
                    title="Are You Sure?"
                    text="This action will permanently delete the extended content for this page!"
                    onConfirm={this.handleFormClear}
                    onCancel={this.toggleDeleteModal}
                    showCancelButton={true}
                    confirmButtonColor="#66BB55"
                    cancelButtonColor="#EF1E25"
                />
                <Form onSubmit={this.handleFormSubmit} >
                    <div>
                        <h5>{`Extend content for page ${currentPageName}`}</h5>
                        <br/>
                        <FormGroup>
                            <Editor {...{
                                editorState,
                                onEditorStateChange: this.handleEditorChange,
                                editorClassName: 'synergy-editor',
                                placeholder: 'Add extended content here...',
                                required:true,
                                toolbar: {
                                    options: ['inline', 'blockType', 'fontSize', 'colorPicker', 'link', 'list', 'image', 'history'],
                                    inline: {
                                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    image: {
                                        uploadCallback: this.uploadCallback,
                                        previewImage: true,
                                        alignmentEnabled: false,
                                    },
                                    link: {
                                        className: 'hideLinkInNewWindowCheckbox',
                                        defaultTargetOption: '_blank',
                                    }
                                }
                            }}/>
                        </FormGroup>
                        <div className="row m-0">
                            <div className="col-sm-6">
                                <Button
                                    bsStyle="danger"
                                    className="p-t-10 p-b-10  btn-block bg-danger"
                                    onClick={this.handleFormClear}
                                    disabled={submitting}
                                >
                                    Clear
                                </Button>
                            </div>
                            <div className="col-sm-6">
                                <Button
                                    bsStyle="primary"
                                    className="p-t-10 p-b-10  btn-block bg-success"
                                    type="submit"
                                    disabled={submitting}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

ExtendedContentEditor.propTypes = {
    currentPageId: PropTypes.string.isRequired,
    currentPageName: PropTypes.string.isRequired,
    extendedContentId: PropTypes.string.isRequired,
    extendedtextId:PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (message, msgType) => dispatch(addFlashMessage(message, msgType)),
});

export default connect(
    null,
    mapDispatchToProps
)(ExtendedContentEditor);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/ExtendedContentEditor.js